/**
 * @fileoverview Copy Button - Reusable hover-reveal copy-to-clipboard button.
 *
 * Used by both scalar field rows and multi-entity cards.
 */
import { Check, Copy } from 'lucide-react';
import React, { useCallback, useState } from 'react';
import { toast } from 'sonner';

export const CopyButton: React.FC<{ value: string }> = ({ value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success('Copied to clipboard');
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Failed to copy');
    }
  }, [value]);

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="mt-0.5 flex-shrink-0 rounded p-0.5 text-zinc-500 opacity-0 transition-opacity hover:bg-zinc-100 hover:text-zinc-700 group-hover:opacity-100 dark:hover:bg-zinc-800 dark:hover:text-zinc-300"
      title="Copy to clipboard"
    >
      {copied ? (
        <Check className="h-3 w-3 text-green-500" />
      ) : (
        <Copy className="h-3 w-3" />
      )}
    </button>
  );
};
